import type { AuthEmailEventType } from "@shyne/shared/api";
import { api } from "@/lib/api";

export type { AuthEmailEventType };

export async function recordAuthEmailEvent(args: {
  eventType: AuthEmailEventType;
  recipientEmail?: string;
  status?: "requested" | "failed";
  payload?: Record<string, unknown>;
  errorMessage?: string;
}): Promise<void> {
  try {
    if (!args.recipientEmail) return;

    await api.authEmailEvents.record({
      eventType: args.eventType,
      recipientEmail: args.recipientEmail,
      status: args.status ?? "requested",
      payload: args.payload ?? {},
      errorMessage: args.errorMessage,
    });
  } catch (error) {
    console.warn("Failed to record auth email event:", error);
  }
}
